import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Container from "./Container";
import Section from "./Section";
import { useHasMounted } from "../hooks/useHasMounted";

export const Trustpilot = ({ background }) => {
  const ref = React.useRef(null);
  const hasMounted =  useHasMounted();
  React.useEffect(() => {
    if (hasMounted && window.Trustpilot ) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, [hasMounted]);

  let themeOptions = {
    site: {
      siteMetadata: {
        trustpilotBusinessUnitId: '59ca23da0000ff0005ac124e'
      }
    }
  }
  if (!process.env.STORYBOOK) {
    themeOptions = useStaticQuery(graphql`
      query ThemeOptionsQuery {
        site {
          siteMetadata {
            trustpilotBusinessUnitId
          }
        }
      }
    `);
  }

  return (
    <Section grey={'grey' === background} lightBlue={'white' !== background && 'grey' !== background}>
      <Container>
        {hasMounted && <div
          ref={ref}
          className="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="53aa8912dec7e10d38f59f36"
          data-businessunit-id={
            themeOptions.site.siteMetadata.trustpilotBusinessUnitId
          }
          data-style-height="140px"
          data-style-width="100%"
          data-theme="light"
          data-stars="5"
          data-review-languages="en"
          data-text-color="#353f3b"
        ></div>}
      </Container>
    </Section>
  );
};
